// Third Party Library
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";

// Constants

// Style
import styles from "../../../index.module.css";

// Components
import { ButtonLink } from "../../../../components";

const SSOFPFooter = ({ loading, page, submit }) => {
  const navigate = useNavigate();

  return (
    <div >
      <Button
        className={styles.buttonForget}
        type="primary"
        htmlType="submit"
        loading={loading}
        onClick={submit}
      >
        Next
      </Button>
      <ButtonLink
        onClick={() => navigate(page)}
        className={styles.buttonBack}
      >
        <ArrowLeftOutlined />
        Go Back
      </ButtonLink>
    </div>
  );
};

export default SSOFPFooter;
